export const PHOTO_GALLERY_API_ROUTES = {
  GET_PHOTO_GALLERY: "/admin/photo-gallery",
  GET_PHOTO_GALLERY_BY_ID: "admin/photo-gallery/:id",
  CREATE_PHOTO_GALLERY: "/admin/photo-gallery",
  UPDATE_PHOTO_GALLERY: "/admin/photo-gallery/:id",
  DELETE_PHOTO_GALLERY: "/admin/photo-gallery/:id",
};
